<mat-progress-bar
	mode="indeterminate"
	[hidden]="!loading"
	style="z-index: 99; top: 0; text-align: center"
	class="position-relative"
></mat-progress-bar>
<mat-autocomplete
	[displayWith]="showSelectedOption ? displayAsSelectedOption : displayAsSelectedOptionEmpty"
	[class]="(smallFont ? 'smallFont ' : '') + (overflow ? '' : 'mep-autocomplete-no_overflow')"
	autoActiveFirstOption
	[autoSelectActiveOption]="false"
>
	<!-- === SingleSelect === -->
	@if (!multiSelect) {
		@for (option of filteredElements | async; track option) {
			<mat-option
				[value]="formatSelectedValue(option)"
				(onSelectionChange)="elementSelected.emit(option)"
				[ngClass]="{'custom-disabled': option === ('mep.general.type-to-search' | translate)}"
			>
				<div [innerHTML]="displayAsDropDownOption(option)" class="option-wrapper"></div>
			</mat-option>
		}
	} @else {
		@for (option of filteredElements | async; track option) {
			<mat-option class="multi-option" (click)="$event.stopPropagation(); toggleSelection(option)">
				<mat-pseudo-checkbox
					class="mat-option-pseudo-checkbox"
					[state]="isSelected(option) ? 'checked' : 'unchecked'"
					(click)="toggleSelection(option); $event.stopPropagation()"
				></mat-pseudo-checkbox>
				<span [innerHTML]="displayAsDropDownOption(option)" class="option-wrapper"></span>
			</mat-option>
		}
	}

	<!-- === MultiSelect === -->
</mat-autocomplete>
